




















import Vue from 'vue';
import {Component} from 'vue-property-decorator';
// @ts-ignore
import store from "../../store";
import DraggableHtmlElement from "../../libs/draggable-html-element/DraggableHtmlElement";

@Component({
    components: {},
    props: {}
})

export default class MessageInformer extends Vue {
    private informerInstance: DraggableHtmlElement|null = null;

    mounted(): void
    {
        this.informerInstance = new DraggableHtmlElement(this.$refs.informer as HTMLElement);
        (this.$refs.informer as HTMLElement).addEventListener('dragEnd', this.dragEnd);
    }

    beforeDestroy(): void
    {
        (this.$refs.informer as HTMLElement).removeEventListener('dragEnd', this.dragEnd);
    }

    /**
     * Состояние игры
     * @private
     */
    private get gameState(): any
    {
        return store.getters.getGameState;
    }

    /**
     * Название раунда
     * @private
     */
    private get roundName(): string
    {
        const round = +this.gameState.tasks.state.currentRound ? this.gameState.tasks.state.currentRound : '1';
        // @ts-ignore
        return this.$t('message.round') + ' ' +  round;
    }

    /**
     * Закончили перетаскивание
     * @param e
     * @private
     */
    private dragEnd(e: any): void
    {
        console.log(e.detail);
    }
}

